import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { InputProps, Props } from './range.type';
import PhoenixReactRange from 'components/common/PhoenixReactRange';
import classNames from 'classnames';

const RangeField = ({ field, form, ...props }: InputProps) => {
  return (
    <>
      <PhoenixReactRange
        {...props}
        values={field.value}
        variant="primary"
        onChange={value => form.setFieldValue(field.name, value)}
        classNames={classNames('mt-3', {
          [props.className || '']: Boolean(props.className)
        })}
      />
    </>
  );
};

export default function Range(props: Props) {
  return (
    <>
      <Field {...props} component={RangeField} />
      {!props.hideMessage && (
        <ErrorMessage
          name={props.name}
          component="div"
          className="invalid-feedback"
        />
      )}
    </>
  );
}
